import { TIME_LINE_DETAIL,TIME_LINE_DETAIL_SUCCESS,TIME_LINE_DETAIL_FAILED,SEND_REMINDER,SEND_REMINDER_SUCCESS,SEND_REMINDER_FAILED } from "./actionTypes"
export const timeLineDetail=(data)=>{
    return{
        type:TIME_LINE_DETAIL,
        payload:{data}
    }
}

export const timeLineDetailSuccess=(data)=>{
    return{
        type:TIME_LINE_DETAIL_SUCCESS,
        payload:{data}
    }
}

export const timeLineDetailFailed=(error)=>{
    return{
        type:TIME_LINE_DETAIL_FAILED,
        payload:{error}
    }

}


export const sendReminder=(data)=>{
    return{
        type:SEND_REMINDER,
        payload:{data}
    }
}

export const sendReminderSuccess=(data)=>{
    return{
        type:SEND_REMINDER_SUCCESS,
        payload:{data}
    }
}

export const sendReminderFailed=(error)=>{
    return{
        type:SEND_REMINDER_FAILED,
        payload:{error}
    }

}